import { Box, styled } from '@mui/material';

const StepperLabelBox = styled(Box)`
  display: flex;
  align-items: center;
  padding-top: 3px;
`;

export default StepperLabelBox;
